function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12.91,
    height: 2.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.35833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 1.075
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.15,
    width: 12.91,
    height: 6.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 5.345
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.54,
    width: 12.91,
    height: 14.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 15.965
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23.39,
    width: 12.91,
    height: 15.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.582
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 31.275
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.16,
    width: 12.91,
    height: 19.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.151666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 48.765
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.37,
    width: 12.91,
    height: 20.56,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8442857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 68.64999999999999
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.93,
    width: 12.91,
    height: 28.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.61375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 93.055
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.18,
    width: 12.91,
    height: 28.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 121.61000000000001
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 136.04,
    width: 12.91,
    height: 30.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.582
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 151.07
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 166.1,
    width: 12.91,
    height: 31.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4344444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 182.045
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 197.99,
    width: 12.91,
    height: 33.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.151666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 214.95000000000002
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.91,
    width: 12.91,
    height: 35.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.151666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 249.575
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 267.24,
    width: 12.91,
    height: 43.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.291
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 288.955
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 310.67,
    width: 12.91,
    height: 52.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.151666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 336.98
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.29,
    width: 12.91,
    height: 57.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 392.09000000000003
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 420.89,
    width: 12.91,
    height: 57.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4344444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 449.85499999999996
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 478.82,
    width: 12.91,
    height: 70.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.61375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 514.0699999999999
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 549.33,
    width: 12.91,
    height: 71.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.151666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 585.095
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 620.86,
    width: 12.91,
    height: 79.14,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.455,
    y: 660.4300000000001
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 0,
    width: 25.35,
    height: 41.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.16875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 25.585,
    y: 20.995
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.26,
    y: 0,
    width: 26.54,
    height: 41.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.53,
    y: 20.995
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.8,
    y: 0,
    width: 26.89,
    height: 41.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.378
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 78.245,
    y: 20.995
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.69,
    y: 0,
    width: 27.11,
    height: 41.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5183333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.245,
    y: 20.995
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.79,
    y: 0,
    width: 31.71,
    height: 41.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.645,
    y: 20.995
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 0,
    width: 38.3,
    height: 41.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.65,
    y: 20.995
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.8,
    y: 0,
    width: 46.33,
    height: 41.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.998333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.965,
    y: 20.995
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.14,
    y: 0,
    width: 51.66,
    height: 41.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.998333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.96999999999997,
    y: 20.995
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.8,
    y: 0,
    width: 56.04,
    height: 41.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.4975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.82,
    y: 20.995
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.83,
    y: 0,
    width: 62.92,
    height: 41.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.24875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.28999999999996,
    y: 20.995
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.75,
    y: 0,
    width: 65.45,
    height: 41.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.4975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.475,
    y: 20.995
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.2,
    y: 0,
    width: 68.02,
    height: 41.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.665555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.21,
    y: 20.995
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.22,
    y: 0,
    width: 71.66,
    height: 41.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.998333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.0500000000001,
    y: 20.995
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.88,
    y: 0,
    width: 89.12,
    height: 41.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.398
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.44,
    y: 20.995
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 41.99,
    width: 70.93,
    height: 54.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 69.47
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 96.95,
    width: 70.93,
    height: 56.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.450000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 125.30000000000001
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 153.65,
    width: 70.93,
    height: 64.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.328666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 186.115
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 218.58,
    width: 70.93,
    height: 70.75,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 253.955
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 289.33,
    width: 70.93,
    height: 72.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.86625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 325.53999999999996
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 361.74,
    width: 70.93,
    height: 79.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.093000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 401.46000000000004
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 441.19,
    width: 70.93,
    height: 81.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.186000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 481.75
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 522.3,
    width: 70.93,
    height: 81.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.821666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 563.295
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.91,
    y: 604.29,
    width: 70.93,
    height: 95.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.448181818181819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 48.375,
    y: 652.145
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.84,
    y: 41.99,
    width: 76.96,
    height: 93.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.32,
    y: 88.535
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.8,
    y: 41.99,
    width: 84.77,
    height: 93.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.185,
    y: 88.535
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.57,
    y: 41.99,
    width: 93.48,
    height: 93.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.31,
    y: 88.535
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.05,
    y: 41.99,
    width: 103.63,
    height: 93.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.865,
    y: 88.535
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.69,
    y: 41.99,
    width: 126.56,
    height: 93.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.29857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.97,
    y: 88.535
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.25,
    y: 41.99,
    width: 130.75,
    height: 93.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.625,
    y: 88.535
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.84,
    y: 135.08,
    width: 123.8,
    height: 114.56,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.812307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.74,
    y: 192.36
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.84,
    y: 249.64,
    width: 123.8,
    height: 136.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.316666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.74,
    y: 317.7
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.84,
    y: 385.76,
    width: 123.8,
    height: 152.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.755555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.74,
    y: 462.255
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.84,
    y: 538.75,
    width: 123.8,
    height: 161.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.379999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.74,
    y: 619.375
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.64,
    y: 135.08,
    width: 145.31,
    height: 143.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.257142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.29499999999996,
    y: 206.88
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.95,
    y: 135.08,
    width: 162.5,
    height: 143.6,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.514285714285712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.2,
    y: 206.88
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.45,
    y: 135.08,
    width: 184.55,
    height: 143.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.054545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.725,
    y: 206.88
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.64,
    y: 278.68,
    width: 204.69,
    height: 209.14,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.985,
    y: 383.25
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.64,
    y: 487.83,
    width: 204.69,
    height: 212.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.743333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.985,
    y: 593.915
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.33,
    y: 278.68,
    width: 287.67,
    height: 421.32,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.151818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.165,
    y: 489.34000000000003
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.714ebb686fe089f7c64e93ef7334c775.svg";
export { ForwardRef as ReactComponent };